import { useSeo } from "@/lib/useSeo";
import { IMG } from "@/lib/images";
import { PageHeader, Section, Prose, Disclaimer } from "@/components/Editorial";

const STEPS = ["Comprendre ses rêves", "Symboles personnels", "Rêves récurrents", "Émotions", "Inconscient", "Interprétation", "Accompagnement"];

export default function Onirotherapie() {
  useSeo({
    title: "Onirothérapie",
    description: "L'onirothérapie selon Dorothée Lancelot : un travail autour du rêve, du symbolisme et de l'inconscient, d'inspiration jungienne. Séance d'une heure, 70 €.",
    path: "/onirotherapie",
    keywords: ["onirothérapie", "thérapie par les rêves", "interprétation des rêves", "signification des rêves", "rêves récurrents", "symbolisme des rêves", "inconscient", "rêve et psychologie jungienne"],
  });

  return (
    <div>
      <PageHeader
        eyebrow="Le travail du rêve"
        title="Onirothérapie"
        intro="Un travail autour du rêve, du symbolisme et de l'inconscient, d'inspiration jungienne."
        image={IMG.libraryCandle}
      />
      <Section>
        <Prose>
          <p>
            Le rêve n'est pas un simple bruit nocturne : il parle un langage de symboles, propre à chacun.
            L'onirothérapie propose d'écouter ce langage, d'en explorer les images récurrentes et les émotions,
            pour mieux se comprendre soi-même. L'approche s'inspire des travaux de Carl Gustav Jung sur le
            symbolisme et l'inconscient.
          </p>
        </Prose>

        <div className="mt-10 flex flex-wrap gap-2.5">
          {STEPS.map((s, i) => (
            <span key={i} className="px-4 py-2 text-sm border border-[rgba(198,167,106,0.25)] text-[#F3E9D2]/75">{s}</span>
          ))}
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="dl-card p-8">
            <div className="dl-eyebrow mb-3">Déroulement d'une séance</div>
            <p className="text-[#F3E9D2]/75 text-sm leading-relaxed">
              La séance part de vos rêves : on les explore ensemble, on relie les symboles à votre histoire
              personnelle et à vos émotions, sans grille figée ni interprétation imposée.
            </p>
          </div>
          <div className="dl-card p-8 flex flex-col justify-center">
            <div className="dl-eyebrow mb-2">Tarif</div>
            <div className="serif text-4xl text-[#D4B978]">70 €</div>
            <div className="text-sm text-[#F3E9D2]/55 mt-1">Séance d'une heure</div>
          </div>
        </div>

        <Disclaimer>L'onirothérapie n'est pas un traitement médical et ne remplace pas un suivi médical ou psychologique.</Disclaimer>
      </Section>
    </div>
  );
}
